import React, { useCallback, useEffect, useMemo } from 'react'
import { useSelector, useDispatch } from 'react-redux'

import projectSelectors from 'store/selectors/project'
import bookingSelectors from 'store/selectors/booking'
import bookingActions from 'store/modules/booking'
import routerSelectors from 'store/selectors/router'
import routerActions from 'store/modules/router'

import FormPage from './FormPage'

const BookingFormDetails = ({
  
}) => {
  const dispatch = useDispatch()
  const initialValues = useSelector(bookingSelectors.detailsValues)
  const options = useSelector(bookingSelectors.options)
  const allSchema = useSelector(bookingSelectors.detailsSchema)
  const formConfig = useSelector(bookingSelectors.slotFormConfig)
  const slot = useSelector(bookingSelectors.slot)
  const stripeConnect = useSelector(projectSelectors.currentProjectStripeConnect)

  const schema = useMemo(() => {
    return allSchema
      .filter(item => {
        if(typeof(item.admin) !== 'boolean') return true
        return !item.admin
      })
  }, [
    allSchema
  ])

  const {
    project,
    bookingform,
  } = useSelector(routerSelectors.params)

  const onBack = useCallback(() => {
    dispatch(routerActions.navigateTo('book.form.customize', {
      project,
      bookingform,
    }))
  }, [
    project,
    bookingform,
  ])

  const onSubmitForm = useCallback(async (payload, direction) => {
    const result = await dispatch(bookingActions.updateReservation({
      details: payload,
    }))
    if(result) {
      dispatch(bookingActions.setDetails(payload))
      dispatch(routerActions.navigateTo('book.form.payment', {
        project,
        bookingform,
      }))
    }
  }, [
    project,
    bookingform,
  ])

  useEffect(() => {
    if(options) return
    dispatch(routerActions.navigateTo('book.form.customize', {
      project,
      bookingform,
    }))
  }, [
    project,
    bookingform,
    options,
  ])

  useEffect(() => {
    if(formConfig) return
    if(!slot) return
    dispatch(bookingActions.loadCalendarConfig({
      project,
      bookingform,
    }))
  }, [
    project,
    bookingform,
    formConfig,
  ])

  if(!slot) return null
  if(!formConfig) return null

  return (
    <FormPage
      withStoreOptions
      withAlert={ stripeConnect ? false : true }
      schema={ schema }
      initialValues={ initialValues }
      onBack={ onBack }
      onSubmit={ onSubmitForm }
    />
  )
}

export default BookingFormDetails